<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-appbar" :class="{'container': false}" 
   :style="{
    'top': $_isMobile ? 45 + 'px' : 80 + 'px',
    }"
  >
    <div class="contain mx-auto">
    <v-tabs
      :show-arrows="$_isMobile"
      class="tab"
      hide-slider
      fixed-tabs
    >
    <v-tab v-for="i in array" :key="i" ref="tabs" 
    class="pa-0 ma-0" @click="$_goTo(i)" :ripple="{ class: 'red--text' }">
      <v-card class="borda-card">
        <div class="flex-column">
          <v-icon class="icon" color="#ba0303" large>mdi-home-silo</v-icon>
          <v-divider></v-divider>
          <span class="font-weight-bold">{{i}}</span>
        </div>
      </v-card>
     </v-tab>
    </v-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreFilaQueue',
  props:{
    array: {type: Array},
    refs : {type: Array}
  },
  data(){
    return {
      teste: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],
    }
  },
  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },

  methods: {
    $_goTo(i) {
      const targetEl = this.refs[i-1];
      this.$vuetify.goTo(targetEl, { duration: 500, offset: 100 });
    },
  },
  watch: {
    array: {
      deep:true,
      handler() {
        console.log('O ARRAY DE ALERTAS FOI ALTERADO',  this.array);
      }
    }
  }
}
</script>


<style>
html {
  overflow-y: none;
}
</style>
<style scoped>

.container {
  display: block;
  margin: 2% 5% 0 10%;
  max-height: 5%;
  height: 100%;
  z-index: 4;
}
.container-appbar{
  display: block;
  width: 100%;
  height: 100%;
  z-index: 4;
}
.icon {
  height: auto;
  font-size: 40px !important;
  margin: 5px 5px;
}
.contain{
  max-width: fit-content;
  display: flex;
}
.borda-card {
  border: 1px solid #ba0303;
  text-align: center;
}
.v-tab{
  min-width: 60px !important;
}
.tab {
  min-height: fit-content;
}
>>> .v-tabs-bar {
  height: 100%!important;
}
>>> .v-item-group .v-slide-group__next {
  min-width: 0;
  width: 0;
  background: transparent !important;
}
>>> .v-item-group .v-slide-group__prev {
  min-width: 0;
  width: 0;
  background: transparent !important;
}


</style>